module.exports = __webpack_public_path__ + "img/4.eff6db5e.jpg";